import { useState } from 'react';
import { DesktopNavigation } from './components/Desktop';
import { MobileNavigation } from './components/Mobile';
import { useMediaQuery } from '@uidotdev/usehooks';
import { APP_DOMAINS } from '~/types';
import { useSession } from '~/components/contexts/SessionProvider';
import { genRoutes } from './utils';
import { ROUTES } from './constants';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useLayoutContext } from '~/components/layout/Layout';

export const Navigation = () => {
  const [appDomain, setAppDomain] = useState<APP_DOMAINS | null>(null);
  const { owner } = useSession();
  const { t } = useTranslation('navigation');
  const { agentId } = useParams();

  const routes = genRoutes(ROUTES, t, owner!, agentId);

  const isSmallDevice = useMediaQuery('only screen and (max-width : 1024px)');

  if (isSmallDevice) {
    return (
      <MobileNavigation
        routes={routes}
        appDomain={appDomain}
        setAppDomain={setAppDomain}
      />
    );
  }

  return (
    <DesktopNavigation
      routes={routes}
      appDomain={appDomain}
      setAppDomain={setAppDomain}
    />
  );
};
